import React, { useEffect, useState } from "react";
import { API_ciudadanos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaPenToSquare, FaRegTrashCan, FaCheck, FaX } from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";

const Digital = ({ usuario }) => {
  const [competencias, setCompetencias] = useState([]);
  const [nuevaCompetencia, setNuevaCompetencia] = useState("");
  const [nuevoNivel, setNuevoNivel] = useState("Medio");
  const [editIndex, setEditIndex] = useState(null);
  const [editCompetencia, setEditCompetencia] = useState("");
  const [editNivel, setEditNivel] = useState("Medio");

  useEffect(() => {
    if (usuario?.userId) {
      fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`)
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data?.DigitalSkills)) {
            const transformadas = data.DigitalSkills.map((item) => ({
              competencia: item.name,
              nivel: item.level.charAt(0).toUpperCase() + item.level.slice(1),
            }));
            setCompetencias(transformadas);
          }
        })
        .catch((err) => console.error("Error al cargar competencias digitales:", err));
    }
  }, [usuario]);

  const formatearParaAPI = (lista) =>
    lista.map((item) => ({
      name: item.competencia,
      level: item.nivel.toLowerCase(),
    }));

  const guardarCambios = async (nuevasCompetencias) => {
    try {
      const body = {
        DigitalSkills: formatearParaAPI(nuevasCompetencias),
      };

      const res = await fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Error al actualizar competencias");

      toast.success("Competencias digitales actualizadas correctamente");
    } catch (err) {
      console.error("❌ Error al guardar competencias digitales:", err);
      toast.error("No se pudieron guardar las competencias digitales");
    }
  };

  const handleAddCompetencia = () => {
    if (nuevaCompetencia.trim() !== "") {
      const actualizadas = [...competencias, { competencia: nuevaCompetencia.trim(), nivel: nuevoNivel }];
      setCompetencias(actualizadas);
      setNuevaCompetencia("");
      setNuevoNivel("Medio");
      guardarCambios(actualizadas);
    }
  };

  const handleEditCompetencia = (index) => {
    setEditIndex(index);
    setEditCompetencia(competencias[index].competencia);
    setEditNivel(competencias[index].nivel);
  };

  const handleSaveEdit = () => {
    const actualizadas = [...competencias];
    actualizadas[editIndex] = { competencia: editCompetencia, nivel: editNivel };
    setCompetencias(actualizadas);
    setEditIndex(null);
    guardarCambios(actualizadas);
  };

  const handleCancelEdit = () => {
    setEditIndex(null);
  };

  const handleDeleteCompetencia = (index) => {
    const actualizadas = competencias.filter((_, i) => i !== index);
    setCompetencias(actualizadas);
    guardarCambios(actualizadas);
  };

  return (
    <div className="competencias caja-verde">
      <h2 className="blanco fondo-verde align-center mayusculas">Competencias Digitales</h2>

      <div className="header between">
        <span className="competencia verde bold">COMPETENCIA</span>
        <span className="nivel verde bold">NIVEL</span>
        <span className="acciones"></span>
      </div>

      <ul className="contenido">
        {competencias.length > 0 ? (
          competencias.map((item, index) => (
            <li key={index} className="row between">
              {editIndex === index ? (
                <>
                  <input
                    className="competencia editar-competencia"
                    type="text"
                    value={editCompetencia}
                    onChange={(e) => setEditCompetencia(e.target.value)}
                  />
                  <select
                    className="nivel editar-competencia"
                    value={editNivel}
                    onChange={(e) => setEditNivel(e.target.value)}
                  >
                    <option value="Básico">Básico</option>
                    <option value="Medio">Medio</option>
                    <option value="Avanzado">Avanzado</option>
                  </select>
                  <div className="check flex gap-5">
                    <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={handleSaveEdit}><FaCheck /></button>
                    <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={handleCancelEdit}><FaX /></button>
                  </div>
                </>
              ) : (
                <>
                  <span className="competencia">{item.competencia}</span>
                  <span className="nivel">{item.nivel}</span>
                  <div className="editar-cv botones-acciones flex gap-5">
                    <button className="fondo-blanco" aria-label="Cambiar la competencia o nivel" onClick={() => handleEditCompetencia(index)}><FaPenToSquare /></button>
                    <button className="fondo-blanco eliminar" aria-label="Eliminar esta competencia" onClick={() => handleDeleteCompetencia(index)}><FaRegTrashCan /></button>
                  </div>
                </>
              )}
            </li>
          ))
        ) : (
          <li className="texto-defecto">Añade competencias que sepas y el nivel</li>
        )}
      </ul>

      <div className="nueva-edicion-rapida flex gap-10 w-100">
        <input
          className="competencia"
          type="text"
          placeholder="Competencia"
          value={nuevaCompetencia}
          onChange={(e) => setNuevaCompetencia(e.target.value)}
        />
        <select className="nivel" value={nuevoNivel} onChange={(e) => setNuevoNivel(e.target.value)} aria-label="Nivel de la nueva competencia">
          <option value="Básico">Básico</option>
          <option value="Medio">Medio</option>
          <option value="Avanzado">Avanzado</option>
        </select>
        <button className="boton estrecho" onClick={handleAddCompetencia}>Añadir</button>
      </div>
    </div>
  );
};

export default Digital;
